import { Paper } from "@mui/material";
import React from "react";

const Notes = ({ cstmr }) => {
  return (
    <Paper className="p-[15px]">
      <p className="whitespace-pre-wrap">{cstmr && (cstmr.note || "Empty")}</p>
    </Paper>
  );
};

export default Notes;
